import { ChallengeInfoForAdmin, ReqCreateOrUpdateChallenge } from '@types';
import {
  ChallengeFormType,
  ConverterData2Form,
  ConverterForm2Data,
} from '../../NewChallengeForm.types';

export const convertForm2Data: ConverterForm2Data<
  Pick<ChallengeFormType, 'thirdTermUrl'>,
  Pick<ReqCreateOrUpdateChallenge, 'thirdTermUrl'>
> = ({ thirdTermUrl }) => {
  return { thirdTermUrl };
};

export const convertData2Form: ConverterData2Form<
  Pick<ChallengeInfoForAdmin, 'thirdTermUrl'>,
  Pick<ChallengeFormType, 'thirdTermUrl'>
> = ({ thirdTermUrl }) => ({ thirdTermUrl });
